module.exports = __webpack_public_path__ + "static/media/logout-line.34a6a82a.svg";